export default __webpack_public_path__ + "static/media/sp.7b5666a7.svg";